import { registerComponent } from './components-front'

registerComponent('filtered-article', _ => {
    document.querySelectorAll('.article-filter').forEach(filter => {
        const filters = filter.querySelectorAll('input[name="blog_category_filter"]');
        let selectedFilters = [];

        filters.forEach(elem => {
            elem.addEventListener('change', ev => {
                if (ev.target.checked) {
                    if (ev.target.id == 'category_8') {
                        selectedFilters = [];
                    } else {
                        if (selectedFilters.length == 1 && selectedFilters[0] == '8') {
                            selectedFilters = [];
                            document.querySelector('#category_8').checked = false;
                        }
                        selectedFilters.push(elem.dataset.categoryId);
                    }
                } else {
                    selectedFilters.splice(selectedFilters.indexOf(elem.dataset.categoryId), 1);
                }

                updateFilteredPosts(selectedFilters);

                if (filter.querySelectorAll('.article').length === filter.querySelectorAll('.article.d-none').length) {
                    document.querySelector('#no-articles-found').classList.remove('d-none');
                } else {
                    document.querySelector('#no-articles-found').classList.add('d-none');
                }

                filter.querySelectorAll('.article').forEach(elem => {
                    elem.classList.remove('first-article');
                })

                $('.article:not(.d-none):first').addClass('first-article');
            })
            
            // Init
            if (elem.checked && elem.id != 'category_8') {
                selectedFilters.push(elem.dataset.categoryId);
                updateFilteredPosts(selectedFilters);
            }
            $('.article:not(.d-none):first').addClass('first-article');
        });

        function updateFilteredPosts(filterArr) {
            document.querySelectorAll('.article').forEach(article => {
                const categories = JSON.parse(article.dataset.tags);

                const found = filterArr.every(i => categories.includes(parseInt(i)));

                if (found) {
                    article.classList.remove('d-none')
                } else {
                    article.classList.add('d-none')
                }
            })
        }
    })
    const pageUrl = new URL(document.URL);
    const searchParams = new URLSearchParams(pageUrl.search);
    if(searchParams.has('search')) {
        const filters = document.querySelectorAll('input[name="blog_category_filter"]');
        filters.forEach(filter => {
            filter.checked = false;
            const searchValue = searchParams.get('search');
            if(filter.getAttribute('data-href-target') == searchValue) {
                filter.click();
            }
        })
    }
})